import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { MyBrandScreenComponent } from './components/my-brand-screen/my-brand-screen.component';
import { Permissions } from './shared/permissions';
import { ManagementScreenComponent } from './components/management-screen/management-screen.component';
import { PolarisRoutePaths, RoutePaths, MessagingRoutePaths, AlertsRoutePaths } from './shared/types/common';
import { MyCompetitionScreenComponent } from './components/my-competition-screen/my-competition-screen.component';
import { MyCampaignsScreenComponent } from './components/my-campaigns-screen/my-campaigns-screen.component';
import { CopilotIndexScreenComponent } from './components/copilot/copilot-index-screen.component';
import { CopilotHomeComponent } from './components/copilot/screens/copilot-home/copilot-home.component';
import { CopilotChatScreenComponent } from './components/copilot/screens/copilot-chat-screen/copilot-chat-screen.component';
import { BrandsFiltersResolverService } from './services/brands-filters-resolver.service';
import { CampaignsFiltersResolverService } from './services/campaigns-filters-resolver.service';
import { BrandsTableComponent } from './components/management-screen/brands-table/brands-table.component';
import { UsersTableComponent } from './components/management-screen/users-table/users-table.component';
import { MessagingScreenComponent } from './components/messaging-screen/messaging-screen.component';
import { MarketingReportComponent } from './components/messaging-screen/marketing-report/marketing-report.component';
import { AccountsTableComponent } from './components/management-screen/accounts-table/accounts-table.component';
import { WorkspaceErrorScreenComponent } from './components/workspace-error-screen/workspace-error-screen.component';
import { AiPresenceScreenComponent } from './components/ai-presence-screen/ai-presence-screen.component';
import { AlertCenterComponent } from './components/alert-center/alert-center.component';
import { AlertViewComponent } from './components/alert-center/alert-view/alert-view.component';
import { CreativeGalleryTabComponent } from './components/messaging-screen/creative-gallery-tab/creative-gallery-tab.component';
import { TrialScreenComponent } from './components/trial-screen/trial-screen.component';
import {SignalsScreenComponent} from './components/signals-screen/signals-screen.component';

export const routes: Routes = [
  { 
    path: RoutePaths.TRIAL, component: TrialScreenComponent
  },
  {
    path: RoutePaths.WORKSPACE_ERROR, component: WorkspaceErrorScreenComponent,
    canActivate: [authGuard]
  },
  {
    path: RoutePaths.POLARIS,
    component: CopilotIndexScreenComponent,
    canActivate: [authGuard],
    resolve: { filters: BrandsFiltersResolverService },
    data: {
      permissions: [Permissions.READ_COPILOT_SCREEN]
    },
    children: [
      { path: '', redirectTo: PolarisRoutePaths.POLARIS_HOME, pathMatch: 'full' },
      { path: PolarisRoutePaths.POLARIS_HOME, component: CopilotHomeComponent },
      { path: `${PolarisRoutePaths.CHAT}/:id`, component: CopilotChatScreenComponent },
      { path: PolarisRoutePaths.CHAT, redirectTo: PolarisRoutePaths.POLARIS_HOME },
      {
        path: PolarisRoutePaths.ALERTS,
        data: {
          permissions: [Permissions.READ_POLARIS_ALERTS, Permissions.WRITE_POLARIS_ALERTS],
          redirectTo: RoutePaths.POLARIS
        },
        children: [
          { path: '', redirectTo: AlertsRoutePaths.ALERT_HOME, pathMatch: 'full' },
          { path: AlertsRoutePaths.ALERT_HOME, component: AlertCenterComponent },
          { path: `${AlertsRoutePaths.ALERT_VIEW}/:id`, component: AlertViewComponent },
        ]
      },
    ]
  },
  {
    path: RoutePaths.MY_BRAND, component: MyBrandScreenComponent,
    canActivate: [authGuard],
    resolve: { filters: BrandsFiltersResolverService },
    data: {
      permissions: [Permissions.READ_MY_BRAND_DASHBOARD],
      redirectTo: RoutePaths.POLARIS
    }
  },
  {
    path: RoutePaths.SIGNALS, component: SignalsScreenComponent,
    canActivate: [authGuard],
    resolve: { filters: BrandsFiltersResolverService },
    data: {
      permissions: [Permissions.READ_SIGNAL],
      redirectTo: RoutePaths.POLARIS
    }
  },
  {
    path: RoutePaths.COMPETITION, component: MyCompetitionScreenComponent,
    canActivate: [authGuard],
    resolve: { filters: BrandsFiltersResolverService },
    data: {
      permissions: [Permissions.READ_MY_COMPETITION_DASHBOARD],
      redirectTo: RoutePaths.POLARIS
    }
  },
  {
    path: RoutePaths.CAMPAIGNS, component: MyCampaignsScreenComponent,
    canActivate: [authGuard],
    resolve: { filters: CampaignsFiltersResolverService },
    data: {
      permissions: [Permissions.READ_MY_CAMPAIGNS_DASHBOARD],
      redirectTo: RoutePaths.POLARIS
    }
  },
  {
    path: RoutePaths.MESSAGING, component: MessagingScreenComponent,
    canActivate: [authGuard],
    resolve: { filters: BrandsFiltersResolverService },
    data: {
      permissions: [Permissions.READ_MESSAGING_SCREEN],
      redirectTo: RoutePaths.POLARIS
    },
    children: [
      { path: '', redirectTo: MessagingRoutePaths.MARKETING_REPORT, pathMatch: 'full' },
      { path: MessagingRoutePaths.MARKETING_REPORT, component: MarketingReportComponent },
      { path: MessagingRoutePaths.CREATIVE_GALLERY, component: CreativeGalleryTabComponent },
      { path: '**', redirectTo: MessagingRoutePaths.MARKETING_REPORT }
    ]
  },
  {
    path: RoutePaths.AI_PRESENCE, component: AiPresenceScreenComponent,
    canActivate: [authGuard],
    resolve: { filters: BrandsFiltersResolverService },
    data: {
      permissions: [Permissions.READ_AI_PRESENCE_SCREEN],
      redirectTo: RoutePaths.POLARIS
    }
  },
  {
    path: RoutePaths.MANAGE, component: ManagementScreenComponent,
    canActivate: [authGuard],
    data: {
      permissions: [Permissions.LIST_USERS,Permissions.WRITE_USER,Permissions.WRITE_BRAND],
      redirectTo: RoutePaths.POLARIS
    },
    children: [
      { path: '', redirectTo: RoutePaths.ACCOUNTS, pathMatch: 'full' },
      { path: RoutePaths.USERS, component: UsersTableComponent, data: { tab: 'users' } },
      { path: RoutePaths.BRANDS, component: BrandsTableComponent, data: { tab: 'brands' } },
      { path: RoutePaths.ACCOUNTS, component: AccountsTableComponent, data: { tab: 'accounts' } },
      { path: '**', redirectTo: RoutePaths.ACCOUNTS }
    ]
  },
  { path: '**', redirectTo: RoutePaths.POLARIS }
];
